export const getELoc = (e) => {
    // let rect = e.target.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;

    return {x, y};
};
